import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export type SelectProductRequest = {
  prazo: number;
  valorParcela: number;
  vencimento: string;
  valorSolicitado: number;
  convenioId?: number;
  tabelaJurosId?: number;
  valorRenda?: number;
  tipoCalculo?: number;
  orgaoId?: number;
  valorDebitoConcorrente?: number;
  dadosAdicionais?: {
    convenioDadosId: number;
    valor: string;
    convenioId: number;
  }[];
};

export type SelectProductResponse = {
  processo: {
    id: number;
    mensagem: string;
  };
  proposta: { id: number } | null;
};

export async function putSelectProduct(
  preTransactionId: string,
  produtoId: number | string,
  payload: SelectProductRequest,
): Promise<SelectProductResponse> {
  const { data } = await httpClient
    .put<SelectProductResponse>(
      `/crefaz-clt/${preTransactionId}/products/${produtoId}`,
      payload,
      { journey: PartnerType.CREFAZ_CLT },
    )
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
